import Current, { type AlertmousePage } from "@/lib/current";
import { init, initRollbar } from "@/lib/init";
import { currentKey } from "@/lib/keys";
import { resolve } from "@/lib/resolve";
import * as Rollbar from "@/lib/rollbar";
import { createInertiaApp } from "@inertiajs/vue3";
import ui from "@nuxt/ui/vue-plugin";
import { createApp } from "vue";

//
// main entry point
//

async function onStart() {
  await init();
  createInertiaApp({
    progress: { color: "var(--color-info)" },
    resolve,
    setup({ el, App, props, plugin }) {
      // amd: this used to be a separate method, but there is a ts tangle when
      // we upgraded inertia
      const initialPage = props.initialPage as AlertmousePage;
      Current.singleton.update(initialPage);
      initRollbar(initialPage.props.cargo);

      const app = createApp({
        progress: true,
        render: () => h(App, Util.transformProps(props)),
      });
      app.use(plugin);
      app.use(ui);
      app.provide(currentKey, Current.singleton);
      app.config.errorHandler = (err, _vm, info) => {
        // https://github.com/rollbar/rollbar.js/issues/1126

        // Show flash in development
        if (import.meta.env.MODE === "development") {
          Util.flash({ alert: `Uh oh - ${Util.extractError(err)}` });
        }

        Rollbar.error(err, info);
        console.error(err);
      };
      app.mount(el);
    },
  });
}

// our <script> tag is in <head>, so the DOM may not be ready yet
document.addEventListener("DOMContentLoaded", onStart);

//
// Inertiajs stores page state in window.history, so that when the user hits the
// back button we can quickly show content without hitting the server. This is
// nice, but sometimes we want to flush old state. For example, if the user
// renames a List and then hits the back button to the dashboard.
//
// This is an experimental fix. Set a flag on popstate (back button pressed),
// and if we detect that the user is headed back to the dashboard force a full
// GET. GET uses preserveState: false, which is what we want here.
//

let backButton = false;
window.addEventListener("popstate", () => (backButton = true));

// hack for GAHH
export const nav: string[] = [];
router.on("navigate", (event) => nav.push(backButton ? "back" : event.detail.page.url));

router.on("navigate", (event) => {
  if (!backButton) return;
  backButton = false;

  const url = event.detail.page.url;
  if (url === Paths.dash) {
    router.get(url, {}, { replace: true });
  }
});
